import {CLASSES, DOM} from '../constants';

const { active, scrolling, overflow, statical } = CLASSES;
const { $window, $header, $burger, $menu, $body } = DOM;
var isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent) && navigator.platform.toUpperCase().indexOf('MAC')>=0;

if (isSafari) {
  $header.css('position', 'fixed');
}
export const stickyHeader = () => {
  if ($window.scrollTop() > 120) {
    $header.addClass(scrolling);
    if (isSafari) {
      $header.css('top', '0px');
    }
  } else {
    $header.removeClass(scrolling);
    if (isSafari) {
      $header.css('top', `-${$window.scrollTop()}px`);
    }
  }
};

export const initMenu = () => {
  $burger.click(() => {
    $burger.toggleClass(active);
    $menu.toggleClass(active);
    $header.toggleClass(active);
    $body.toggleClass(overflow);
  });
};

